export const items = [
  {
    id: 1,
    title: 'Fitbit', 
    description: 'Makes tracking your exercise minutes, heart rate and sleep effortless',
    points: 350,
    imageURL: 'https://res.cloudinary.com/dbnasq0ef/image/upload/v1602216385/fitbit_y0swh4.jpg',
    type: ['EXERCISE'],
  },
  {
    id: 2,
    title: 'Farm Fresh Box', 
    description: 'One Fresh fruit and vegetables delivered to your door.',
    points: 350,
    imageURL: 'https://res.cloudinary.com/dbnasq0ef/image/upload/v1602216387/farmbox_wx7x83.png',
    type: ['FRUITS_AND_VEGGIES'],
  },
  {
    id: 3,
    title: 'Mobile Mammogram', 
    description: 'Free mammogram screening at mobile locations in your area',
    points: 350,
    imageURL: 'https://res.cloudinary.com/dbnasq0ef/image/upload/v1602349684/Mobile_Mammogram_cohiay.jpg',
    type: ['MAMMOGRAM', 'SELF_CHECK'],
  },
  {
    id: 4,
    title: 'Yoga Class', 
    description: '10 free classes at Yoga Studio',
    points: 750,
    imageURL: 'https://res.cloudinary.com/dbnasq0ef/image/upload/v1602349680/Yoga_lihfpp.jpg',
    type: ['EXERCISE'],
  },
  {
    id: 5,
    title: 'Month Gym Membership', 
    description: 'Free access for a month at Gym',
    points: 750,
    imageURL: 'https://res.cloudinary.com/dbnasq0ef/image/upload/v1602216387/gym_wtht2n.jpg',
    type: ['EXERCISE'],
  },
  {
    id: 6,
    title: '3 month Farm Fresh Box Subscription', 
    description: 'Fresh fruit and vegetables delivered to your home for 3 months',
    points: 750,
    imageURL: 'https://res.cloudinary.com/dbnasq0ef/image/upload/v1602216387/farmbox_wx7x83.png',
    type: ['FRUITS_AND_VEGGIES']
  },
  {
    id: 7,
    title: 'Physical Therapy Consultation', 
    description: 'Meet with a Physical Therapist for an hour consultation',
    points: 1000,
    imageURL: 'https://res.cloudinary.com/dbnasq0ef/image/upload/v1602216385/physcial_therapy_cgf8ls.jpg',
    type: ['EXERCISE']
  },
  {
    id: 8,
    title: 'Nutritionist Consultation', 
    description: 'Meet with a Nutritionist and discuss your goals for healthy eating',
    points: 1000,
    imageURL: 'https://res.cloudinary.com/dbnasq0ef/image/upload/v1602216387/nutritionist_kyjhk8.jpg',
    type: ['FRUITS_AND_VEGGIES', 'MINDFULNESS']
  },
  {
    id: 9,
    title: 'Therapy Consultation', 
    description: 'Meet with a Licensed Therapist',
    points: 1000,
    imageURL: 'https://res.cloudinary.com/dbnasq0ef/image/upload/v1602216387/therapy_bbcmit.png',
    type: ['MINDFULNESS'],
  },
  {
    id: 10,
    title: 'Blue Apron Meal Kit', 
    description: '2 serving meal kits, 3 times a week for a month delivered to your door',
    points: 1000,
    imageURL: 'https://res.cloudinary.com/dbnasq0ef/image/upload/v1602216384/blue_apron_kniyzk.jpg',
    type: ['FRUITS_AND_VEGGIES'],
  },
  {
    id: 11,
    title: 'Community Pop-up Farm Stand with Mobile Mammogram', 
    description: 'Bring to your community for a day a Pop-Up Farm Stand that will also have a Mobile Mammogram',
    points: 2500,
    imageURL: 'https://res.cloudinary.com/dbnasq0ef/image/upload/v1602216387/farmstand_zqn6dc.jpg',
    type: ['FRUITS_AND_VEGGIES'],
  },
  {
    id: 12,
    title: 'Social Worker Consultation', 
    description: 'Meet with a Social Worker who can provide you with individual counseling. He/she can even guide you through the process of applying for various funds and assistance related to breast health.',
    points: 1000,
    imageURL: 'https://res.cloudinary.com/dbnasq0ef/image/upload/v1602216386/social_work_jtharl.png',
    type: ['MINDFULNESS', 'SELF_CHECK', 'MAMMOGRAM'],
  },
]